export const AGENT_SESSION_PARAM = "agentSession";

/** `?openAgent=true` opens the sidebar on its default panel, then is stripped. */
export const OPEN_AGENT_PARAM = "openAgent";

/** `?agentNudge=<prompt>` prefills the composer without submitting, then is stripped. */
export const AGENT_NUDGE_PARAM = "agentNudge";

/**
 * Search params with the agent session param set to `sessionId`, or removed when
 * it is null. Returns null when the params already match: React Router's
 * `setSearchParams` navigates even for an identical value, and a redundant
 * navigation from a mount effect can abort another navigation in flight (such
 * as the audience index redirect to the definition tab).
 */
export function withAgentSessionParam(
  current: URLSearchParams,
  sessionId: string | null,
): URLSearchParams | null {
  const target = sessionId || null;
  if ((current.get(AGENT_SESSION_PARAM) ?? null) === target) {
    return null;
  }
  const next = new URLSearchParams(current);
  if (target) {
    next.set(AGENT_SESSION_PARAM, target);
  } else {
    next.delete(AGENT_SESSION_PARAM);
  }
  return next;
}
